<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      width="550"
    >
      <v-card>
        <v-card-title>
          <h4 class="titleText--text">Add details for {{variablename}}</h4>
          <v-spacer />
          <v-btn icon color="titleText" @click="closeForm()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="mt-3">
          <v-select
            v-model="selectedregionvalue"
            :items="Item_regionlist"
            placeholder="Select Region"
            solo
            flat
            background-color="#F3F5F8"
            hide-details
          >
          </v-select>
          <div class="d-flex justify-space-between mt-3">
            <v-select
              v-model="selectedvarvalue"
              :items="Item_newvar_creation_varlist"
              placeholder="Select variable"
              solo
              flat
              background-color="#F3F5F8"
              hide-details
            >
            </v-select>
            <v-text-field
              v-model="txtweight"
              :counter="50"
              placeholder="Weight"
              solo
              flat
              background-color="#F3F5F8"
              hide-details
              class="ml-2"
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :disabled="!selectedregionvalue && !selectedvarvalue"
            class="ml-2"
            color="blue"
            depressed
            height="36"
            width="120"
            @click="savevariabledetails()"
          >
            <span class="text-capitalize font-weight-bold" :class="(!selectedregionvalue && !selectedvarvalue) ? 'titleText--text' : 'white--text'">Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
//import { bus} from '../../../main';
import apifactory from "../api";
export default defineComponent({
  setup() {},
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
    variablename: "",
    varid: 0,
    Item_newvar_creation_varlist: [],
    selectedvarvalue: null,
    txtweight: "",
    currentloginuser: 9,
    ItemAllvariableDetails: [],
    Item_regionlist: [],
    selectedregionvalue: null,
  }),
  methods: {
    closeForm() {
      this.dialog = false;
      this.$emit("refreshvariablegrid");
    },
    savevariabledetails() {
      //alert(this.selectedvarvalue.id);
      if (
        typeof this.selectedregionvalue == "undefined" ||
        this.selectedregionvalue == null
      ) {
        return;
      }
      if (
        typeof this.selectedvarvalue == "undefined" ||
        this.selectedvarvalue == null
      ) {
        return;
      }
      if (
        typeof this.txtweight == "undefined" ||
        this.txtweight == null ||
        this.txtweight == ""
      ) {
        return;
      }

      apifactory
        .call_save_newvar_detail(
          this.varid,
          this.selectedvarvalue,
          this.txtweight,
          this.selectedregionvalue
        )
        .then(() => {
            this.txtweight = null;
            this.selectedvarvalue = null;
            this.selectedregionvalue = null;
            // this.getAllvariabledetails();
            this.dialog = false
            this.$emit('onSaveDetails')
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    getAllvariabledetails() {
      apifactory
        .call_save_newvar_detail_byid(this.varid)
        .then((res) => {
          if (res.status != 200) {
            alert(res.message);
          } else {
            this.ItemAllvariableDetails = res.data;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    binddefalutvalues(varid, varname) {
      // alert('call from parent' + varid);
      //alert('call from parent' + varname);

      this.dialog = true;
      this.variablename = varname;
      this.varid = varid;
      this.txtweight = "";
      this.selectedvarvalue = null;
      this.getnewvar_creation_varlist();
      this.getAllvariabledetails();
    },

    getnewvar_creation_varlist() {
      //apifactory.newvar_creation_varlist()
      apifactory
        .call_get_varlist_for_newvar()
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            //this.reset();
            // let tempdata = res.data;
            this.Item_newvar_creation_varlist = [];
            this.Item_regionlist = [];
            /*   for (var k in tempdata) {
                            this.Item_newvar_creation_varlist.push(tempdata[k]);
                        }*/
            this.Item_newvar_creation_varlist = res.data.variable_list;
            this.Item_regionlist = res.data.region_list;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    delete(varid) {
      //.newvariableDetail_Delete(varid, this.currentloginuser, this.varid)
      apifactory
      .call_save_newvar_detail_delete(varid, this.varid,this.currentloginuser)
                .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.dialog = true;
            this.getAllvariabledetails();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    showAlertConfirm(varid) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.delete(varid);

          /*this.$swal(
                        'Deleted!',
                        'Your Data has been deleted.',
                        'success'
                    )*/
        }
      });
    },
  },
  mounted() {
    // bus.$on('submit', this.binddefalutvalues)
    //this.getnewvar_creation_varlist()
  },
});
</script>
